/* unplugin-vue-components disabled */import script from "./swiperBox.vue?vue&type=script&lang=jsx"
export * from "./swiperBox.vue?vue&type=script&lang=jsx"

import "./swiperBox.vue?vue&type=style&index=0&id=f7a9242a&lang=less&scoped=true"

import exportComponent from "/data1/jenkins/master_project/website-sszx/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f7a9242a"]])

export default __exports__